import React from 'react';


const Footer = () => {
    return (
        <footer className="site-footer">
            <p>Fatima zahrae ZERHERI |  Copyright 2025 | All Rights Reserved.</p>
        </footer>
    );
};

export default Footer;